import styled, { css } from 'styled-components';
import { Box, BoxProps } from '@bechtel/gds';

export const DeleteAttachmentStyled = styled.div`
  position: absolute;
  ${({ theme }) => css`
    top: ${theme.spacings[400]};
    right: ${theme.spacings[400]};
  `}
`;

export const BlockImgStyled = styled.img`
  cursor: pointer;
  border-radius: ${({ theme }) => theme.radii[300]};
`;

export const ResolveSubHeadingStyled = styled(Box).attrs({
  pt: { sm: '550' },
  pb: { sm: '500' },
  pl: { sm: '500' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    border-bottom: 1px solid ${theme.colors.grey[300]};
  `}
`;

export const ListContainerStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  & > :not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings[300]};
  }
`;

export const AttachmentContainerStyled = styled(Box).attrs({ flexDirection: { sm: 'column' }, mt: { sm: '500' } })`
  & > :not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings[500]};
  }
`;